import { saveAs } from "file-saver";

import { Icon } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import Form from "../../../../forms/components/Form/Form";
import Button from "../../../../ui/components/Buttons/Button";
import CoverImage from "../../../../ui/components/CoverImage/CoverImage";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";
import Dropzone from "../../../../ui/components/Dropzone/Dropzone";
import ErrorModal from "../../../../ui/components/ErrorModal/ErrorModal";
import themeColors from "../../../../ui/constants/themeColors";
import useSingleFileUpload from "../../../../ui/hooks/useSingleFileUpload";

export default function ArticleEditCover({ article, disabled }) {
	const { t } = useTranslation();

	const { watch, setValue } = Form.useFormContext();

	const [{ input, loading, error, uploadFile }, onUploadFile] = useSingleFileUpload({
		bucketName: "earselect-uploads",
		getDestination: (file) => {
			const extension = file.name.split(".").pop();

			return `covers/${article.id}-${Date.now()}.${extension}`;
		},
		onSuccess: (cover) => {
			return setValue("cover", cover, { shouldDirty: true });
		},
	});

	const cover = watch("cover");

	if (!cover) {
		const onDropFiles = async (files) => {
			await onUploadFile({ target: { files } });
		};

		return (
			<Dropzone accept={{ "image/*": [] }} style={{ width: 150, minHeight: 150 }} onDropFiles={onDropFiles}>
				<div style={{ opacity: 0.2 }}>
					<Icon name="picture" size="huge" />
				</div>
			</Dropzone>
		);
	}

	return (
		<div style={{ position: "relative", marginBottom: 10 }}>
			<CoverImage rounded size={150} data={{ cover }} loading={loading} />

			<DropdownMenu
				direction="right"
				trigger={
					<Button
						circular
						size="mini"
						style={{
							height: 22,
							lineHeight: "2px",
							backgroundColor: "var(--color-bg-card)",
							border: `1px solid ${themeColors.BORDER}`,
						}}
					>
						{t("edit", "Edit")}
					</Button>
				}
				options={[
					{
						text: t("upload", "Upload"),
						onClick: uploadFile,
						disabled,
					},
					{
						text: t("download", "Download"),
						hidden: !cover,
						onClick: () => saveAs(cover.url, `${article.name}-cover.jpg`),
					},
					{
						text: t("remove", "Remove"),
						hidden: !cover,
						confirmText: t("confirmRemoveCover", "Are you sure you want to remove this cover?"),
						disabled,
						action: () => {
							return setValue("cover", null, { shouldDirty: true });
						},
					},
				]}
				style={{
					position: "absolute",
					bottom: 0,
					left: "50%",
					zIndex: 10,
					transform: "translate(-50%, 50%)",
				}}
			/>

			{input}

			{error && <ErrorModal error={error} />}
		</div>
	);
}
